"use client";
import { getTranslation } from "@/i18n/get-translation";
import { getBlogCategories } from "@/services/blogs-category.service";
import { ICategory, ICategoryResponse } from "@/types/category.type";
import Footer from "@components/footer/footer";
import MoveToTop from "@components/move-to-top/move-to-top";

import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import SubCategories from "@components/sub-categories/sub-categories";
import SubHeader from "@components/sub-header/sub-header";
import BlogFeaturePosts from "@components/blog-components/blog-feature-posts/blog-feature-posts";
import BlogTrendingPosts from "../blog-trending-posts/blog-trending-posts";
import BlogRecentPosts from "../blog-recent-posts/blog-recent-posts";
import InnerSubCategories from "@components/inner-sub-categories/innner-sub-categories";

interface IBlogMainPage {
  locale: string;
}
const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
export default function BlogMainPage({ locale }: IBlogMainPage) {
  const [blogCategories, setBlogCategories] = useState<ICategoryResponse>(init);
  const t = getTranslation(locale, "innerSubCategories");
  const router = useRouter();
  const searchParams = useSearchParams();
  const search = searchParams.get("category");
  const [selectedBlogCategories, setSelectedBlogCategories] =
    useState<string>("");

  const handleSelectBlogCategory = useCallback(
    (item: ICategory) => {
      if (item.id === -1) {
        setSelectedBlogCategories(t("all"));
        router.push(`/${locale}/blog`);
      } else {
        setSelectedBlogCategories(item.attributes.name);
        router.push(`?category=${item.attributes.name}`);
      }
    },
    [router, locale, t]
  );
  useEffect(() => {
    const lang =
      locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;
      getBlogCategories(lang)
      .then((response: ICategoryResponse) => {
        setBlogCategories(response);
      })
      .catch(console.log);
  }, [locale, router]);
  useEffect(() => {
    if (search) {
      setSelectedBlogCategories(search);
    } else {
      setSelectedBlogCategories(t("all"));
    }
  }, [search, t]);

  return (
    <>
      <InnerSubCategories
        locale={locale}
        categories={blogCategories}
        handleSelect={handleSelectBlogCategory}
        selected={selectedBlogCategories}
      />
      <BlogFeaturePosts locale={locale} />
      <BlogTrendingPosts locale={locale} />
      <BlogRecentPosts locale={locale} blogCategory={selectedBlogCategories} />
    </>
  );
}
